export default "__VITE_ASSET__BApKIAR0__"